// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DmUPU","comment":"styles_comment__D8Y6P"};